function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@bydesign-ui/utils';
import React from 'react';
import { usePrefixCls } from '@byte-design/config';
export function DateContainer(props) {
  var header = props.header,
      footer = props.footer,
      preset = props.preset,
      className = props.className,
      children = props.children,
      onResetPanel = props.onResetPanel,
      resetOnMouseLeave = props.resetOnMouseLeave,
      extra = _objectWithoutProperties(props, ["header", "footer", "preset", "className", "children", "onResetPanel", "resetOnMouseLeave"]);

  var containerCls = classnames(usePrefixCls('date-container'), className);
  var headerCls = usePrefixCls('date-container-header');
  var footerCls = usePrefixCls('date-container-footer');
  var contentCls = usePrefixCls('date-container-content');
  var contentPresetCls = usePrefixCls('date-container-content-preset');
  var contentInnerCls = usePrefixCls('date-container-content-inner');

  var renderHeader = function renderHeader() {
    if (!header) {
      return null;
    }

    return React.createElement("div", {
      className: headerCls
    }, header);
  };

  var renderFooter = function renderFooter() {
    if (!footer) {
      return null;
    }

    return React.createElement("div", {
      className: footerCls
    }, footer);
  };

  var renderPresets = function renderPresets() {
    if (!preset) {
      return null;
    }

    return React.createElement("div", {
      className: contentPresetCls
    }, preset);
  };

  return React.createElement("div", Object.assign({}, extra, {
    className: containerCls,
    onMouseLeave: resetOnMouseLeave && onResetPanel || undefined
  }), renderHeader(), React.createElement("div", {
    className: contentCls
  }, renderPresets(), React.createElement("div", {
    className: contentInnerCls
  }, children)), renderFooter());
}